import { connect } from 'react-redux'
import { hasRole } from '#/consts/plan'
import { UpdateStates } from '#/store/actions/ui'
import { RequestReport } from '#/store/actions/workspace'
import { currentRole } from '#/store/selectors/user'
import ReportsPurchase from './ReportsPurchase'

const mapStateToProps = (state: TopHap.StoreState) => ({
  authenticated: state.user.info.isAnonymous === false,
  hasRole: hasRole(currentRole(state), 'pro'),
  user: state.user.info
})

const mapDispatchToProps = {
  requestReport: RequestReport,
  showCTAPopup: (visible: boolean, requireRole?: TopHap.UserRole) =>
    UpdateStates({ ctaPopup: { visible, requireRole } })
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPurchase)
